<template>
  <div class="detail-card">
    <div class="detail-card-head">
      <div class="detail-card-head_title flex-1">我的企业/单位关注</div>
      <div v-if="total > 0" class="detail-card-head-right">
        <a-button
          style="height: auto; color: #CB9D46"
          type="link"
          @click="toBiddogFollowCompany"
        >查看更多</a-button>
      </div>
    </div>
    <div class="detail-card-body">
      <div v-if="total > 0" class="list list-wrap">
        <follow-company-item
          v-for="item in followedCompanyList"
          :key="item.id"
          :info="item"
        />
      </div>
      <div v-else class="empty-wrap list-wrap">
        <img
          :src="
            require('@/assets/images/personal-center/vip-home/empty-follow-company.png')
          "
          style="width: 100px; height: 100px"
          alt=""
        />
        <div class="empty-tip">
          尚未关注企业？立即前往
          <a-button
            type="link"
            class="vip-color"
            style="height: auto; padding: 0"
            @click="toBiddogPurchaserPage"
          >采购单位分析</a-button>
          或
          <a-button
            type="link"
            class="vip-color"
            style="height: auto; padding: 0"
            @click="toBiddogCompetitorPage"
          >竞争对手分析</a-button>
          搜索并关注您感兴趣的企业/单位。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import FollowCompanyItem from '@/components/ValueAddedService/FollowCompanyItem'
// 接口
import { getFollowedCompanyPageApi } from '@/api/value-added-service'
// 字典
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
// 工具
import { toBiddogPage } from '@/utils/utils'
// vuex
import { mapState } from 'vuex'

export default {
  name: 'VipFollowCompany',

  components: { FollowCompanyItem },

  data() {
    return {
      // 已关注企业列表
      followedCompanyList: [],
      total: 0
    }
  },

  computed: {
    ...mapState('user', ['vipInfo', 'vipBalance'])
  },

  methods: {
    /**
     * 查询已关注企业列表
     */
    getFollowedCompanyPage() {
      getFollowedCompanyPageApi({ page: 1, size: 5 })
        .then(res => {
          this.followedCompanyList = res.data.records || []
          this.total = res.data.total || 0

          // 根据已关注的项目数量，计算关注企业剩余数量
          const productCode = this.vipInfo?.productInfo?.productCode
          let remain = 0
          if (productCode === valueAddedProductCodeDict.DIAMOND_VIP.value) {
            remain = 500 - this.total
          }
          if (productCode === valueAddedProductCodeDict.ADVANCED_VIP.value) {
            remain = 100 - this.total
          }
          const follow_company = { remain }
          this.$nextTick(() => {
            this.$store.commit('user/ADD_VIP_BALANCE', {
              follow_company
            })
          })
        })
        .catch(err => {
          console.error(err)
          if (err?.data?.message) this.$message.error(err.data.message)
        })
    },

    /**
     * 前往标前狗企业关注页
     */
    toBiddogFollowCompany() {
      toBiddogPage('/follow/company')
    },

    /**
     * 前往标前狗采购单位查询
     */
    toBiddogPurchaserPage() {
      toBiddogPage('/purchaser-analysis/list')
    },

    /**
     * 前往标前狗竞争对手查询
     */
    toBiddogCompetitorPage() {
      toBiddogPage('/competitor-analysis/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-card {
  background-color: $white-color;
  border-radius: 4px;
  padding: 20px 24px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .detail-card-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .detail-card-head_title {
      font-size: 16px;
      color: $text-color;
      @include text-bold;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: $member-fifth-color;
        margin-right: 6px;
        vertical-align: -12%;
      }
    }

    .detail-card-head_sub {
      font-size: 12px;
      color: $text-third-color;
      margin-left: 8px;
    }
  }
}

.list-wrap {
  border-top: 1px solid $info-fourth-color;
}

.vip-color {
  color: #cb9d46;
}

.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 110px 48px 120px;

  .empty-tip {
    text-align: center;
    color: $text-second-color;
    margin-top: 16px;
    line-height: 24px;
  }
}
</style>
